<template>
  <div>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="red darken-4" dark>
        <v-card-text class="text-xs-center">
          Por favor espere
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppsNavBar from "@/components/utiles/AppsNavBar.vue"
import { mapActions } from "vuex"
import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
export default {
  name: "inicio",
  components: {},
  mounted() {
    this.getData()
  },
  beforeCreate() {},
  methods: {
    async getData() {
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let axios = new AxiosHandler()
      axios.setPassportHandler(this.$passporthandler)
      axios.prepare(`${process.env.VUE_APP_ASBACK}/api/json-mensaje/${this.$route.params.id}`, header)
      axios.overlay(false)
      await axios.exe()
      const data = axios.getData()
      this.manejoRs(data.data, axios.getStatus())
    },
    manejoRs(data, status) {
      if (status != 200) {
        this.showToasted(
          "Ocurrio un error inesperado, será redirigico al inicio, por favor contacte al administrador.",
          "error",
          10000
        )
        this._$goToInicio()
        return
      }
      this.rsOK(data)
    },
    rsOK(data) {
      this.$store.dispatch("carrito/prepararcarritoFromDb", data.carrito)
      this.$store.dispatch("app/guardarUsuario", data.usuarioWeb)
      this.$router.replace({
        name: "facturacion",
        params: { data: data.reserva }
      })
    }
  },
  data() {
    return {
      loading: true
    }
  }
}
</script>
